import MasterCrudPage from "../../components/MasterCrudPage";
import { orderStatusMasterApi } from "../../api/masterApi";

export default function OrderStatusMaster() {
  return (
    <MasterCrudPage
      title="Order Status Master"
      description="Manage order statuses used by Order Master."
      idKey="order_status_id"
      api={orderStatusMasterApi}
      listLabel="order statuses"
      useJson
      fields={[
        {
          name: "order_status_name",
          label: "Order Status",
          type: "text",
          required: true,
          fullWidth: true,
          placeholder:
            "e.g. Wishlist, Track, Broadcast, Cart, Order Confirmed, Dispatched, In Transit, Shipped/ Delivered",
        },
      ]}
      columns={[
        { key: "order_status_id", label: "Order Status" },
        { key: "order_status_name", label: "Order Status" },
      ]}
    />
  );
}
